/*
 * @Author: caiqin.xie
 * @since: 2023-06-09 14:56:39
 * @lastTime: 2023-11-10 17:06:45
 * @LastEditors: caiqin.xie
 * @message: 最新新闻
 */
import React from 'react'
import styles from '../../index.module.scss'
import LazyMedia from '@/components/LazyMedia'
import { INews } from '@/common/types'

interface IProps {
  ctry: string;
  words: Record<string, string>;
  relatedList: INews[]; // 最新新闻列表
  device: string;
}

const RelatedArticles = (props: IProps) => {
  const { ctry, words, relatedList, device } = props

  return (
    <>
      {relatedList && relatedList.length > 0 && (
        <div className={styles['related-articles']}>
          <div className={styles['related-articles-title']}>
            <h3>{words?.blog_news_title}</h3>
            {device !== 'mobile' && (
              <a href={`/${ctry}/newsroom`}>
                <span className={styles['more-news']}>{words?.blog_see_all_articles}</span>
              </a>
            )}
          </div>
          <div className={styles['related-articles-content']}>
            {relatedList.slice(0, 4).map((item, index) => (
              <div className={styles['relate-item']} key={item.id} onClick={() => window.open(`/${ctry}/newsroom/${item.seoUrl}`, '_self')}>
                <div className={styles['news-pic']}>
                  <LazyMedia type="image" LazyClassName="full-wh" src={item?.cover} alt={item?.coverAlt} />
                </div>
                <div className={styles['news-content']}>
                  <p className={styles['news-title']}>{item?.title}</p>
                </div>
              </div>
            ))}
          </div>
          {device === 'mobile' && (
            <p className={styles['more-news-wrap']}>
              <a href={`/${ctry}/newsroom`}>
                <span className={styles['more-news']}>{words?.blog_see_all_articles}</span>
              </a>
            </p>
          )}
        </div>
      )}
    </>
  )
}
export default RelatedArticles
